export default {
  namespaced: true,

  state: () => ({
    model: {},
  }),

  getters: {
    model: (state) => state.model,
  },

  mutations: {
    setQuickViewModel(state, model) {
      state.model = { ...model };
    },
  },
};
